<template>
    <div>
        <!-- SECCIONES -->
        <vs-tabs v-if="isMounted" v-model="activeTab"
            class="tabs-shadow-none" id="profile-tabs">
            <vs-tab :label="group.title" icon-pack="feather" :icon="group.icon" v-for="(group, i) in getSectionGroups()"
                :key="i">
                <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
                    <vx-card no-shadow>
                        <div class="vx-row">
                            <!-- tabs -->
                            <vs-tabs v-model="activeTab1">
                                <vs-tab label="Financiamiento">
                                    <!-- Sobre el financiamiento -->
                                    <div class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="FolderIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Sobre el financiamiento</h3>
                                            </div>
                                            <div class="vx-row">
                                                <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                                                    <ul class="list-bold">
                                                        <li>
                                                            Tipo de financiamiento:
                                                            <span>{{ translateLoanType(financeLoanData.loan_type) }}</span>
                                                        </li>
                                                        <li>
                                                            Tipo de crédito:
                                                            <span>{{ translateCrowdfundingLoanType(financeLoanData.crowdfunding_loan_type) }}</span>
                                                        </li>
                                                        <li>
                                                            Monto a financiar:
                                                            <span>{{ format_price(financeLoanData.financed_amount, 0) }}</span>
                                                        </li>
                                                        <li>
                                                            Plazo: <span>{{ financeLoanData.loan_term }} meses</span>
                                                        </li>
                                                        <li>
                                                            Días máximos de fondeo:
                                                            <span>{{ financeLoanData.max_funding_days }}</span>
                                                        </li>
                                                        <li>
                                                            Tasa de interés: <span>{{ (financeLoanData.interest_rate *
                                                                    100).toFixed(2)
                                                            }}%</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                                                    <ul class="list-bold">
                                                        <li>
                                                            Garantías: <span>
                                                                <ul class="guarantees-list">
                                                                    <li v-for="guarantee in financeLoanData.loan_guarantees">
                                                                        {{ translateGuaranteeType(guarantee.type) }}
                                                                        ({{ guarantee.name }})</li>
                                                                </ul>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            Calificación
                                                            crediticia:<span>&nbsp;{{ financeLoanData.loan_qualification }}</span>
                                                        </li>
                                                        <li>
                                                            Participación de RedGirasol: <span>{{ (financeLoanData.rg_investment
                                                                    * 100).toFixed(0)
                                                            }}%</span>
                                                        </li>
                                                        <li>
                                                            Inversionistas: <span>
                                                                {{ format_price(publicProjectData.project.inversionistas, 0) }}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            Enganche: <span>
                                                                {{ financeLoanData.loan_type == 1 ?
                                                                        (financeLoanData.deposit_percentage * 100).toFixed(0) + '%' :
                                                                        "No aplica"
                                                                }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                                                    <div v-for="section in getSectionsForGroup(group)" :key="section.data.id">
                                                        <div v-if="section.data.id == 95">
                                                            <div class="vx-row">
                                                                <template v-for="f in section.data.fields">
                                                                    <!-- Campos automaticos -->
                                                                    <form-field
                                                                        :ref="'section' + section.data.id"
                                                                        v-if="(isAutoFormField(f) && f.fname == 'funding_days')"
                                                                        :key="f.id"
                                                                        :f="f"
                                                                        :keepDisabled="isDisabled"
                                                                        :dataContainer="getContainerForField(section, f)"
                                                                        :collectionsRoot="collections"
                                                                        :onChangeReceptor="onFieldChange"
                                                                        :hasBackofficeAccess="hasBackofficeAccess"
                                                                        :inputClassLarge="true"
                                                                        :evaluator="evaluateCondition" />
            
                                                                </template>
                                                            </div>
            
                                                            <!-- Save Button -->
                                                            <div class="vx-row" v-if="!isDisabled && !section.data.skipBtn">
                                                                <div class="flex flex-wrap items-center justify-end">
                                                                    <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="vx-col w-full m-4 mb-base">
                                                    <vs-divider></vs-divider>
                                                    <vs-collapse>
                                                        <vs-collapse-item>
                                                            <div class="black" slot="header">
                                                                Plan de pagos
                                                            </div>
                                                            <div class="vx-col w-full">
                                                                <div v-if="canAskForRefund" class="vx-col lg:w-3/4 w-full mb-4">
                                                                    Las fechas del plan de pagos durante la etapa de fondeo son estimados y podrían variar al iniciar
                                                                    el proceso de instalación. Para un reembolso de tus fondos, da clic
                                                                    <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="onRefundClick">aquí.</router-link></span>
                                                                </div>
                                                                <vs-table id="payments-table" :data="financeLoanData.payment_plan" stripe max-items="10" pagination noDataText="No hay registros disponibles">
                                                                    <template slot="thead">
                                                                        <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                                                    </template>
                                
                                                                    <template slot-scope="{data}">
                                                                        <tbody>
                                                                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                                                            <vs-td>
                                                                                {{tr.number}}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{tr.payment_date}}
                                                                            </vs-td>
                                                                            <vs-td>${{format_price(tr.payment)}}</vs-td>
                                                                            <vs-td>${{format_price(tr.initial_debt)}}</vs-td>
                                                                            <vs-td>${{format_price(tr.amortization)}}</vs-td>
                                                                            <vs-td>${{format_price(tr.interest)}}</vs-td>
                                                                            <vs-td>${{format_price(tr.tax)}}</vs-td>
                                                                            <vs-td>${{format_price(tr.final_debt)}}</vs-td>
                                                                        </vs-tr>
                                                                        </tbody>
                                                                    </template>
                                                                </vs-table>
                                                            </div>
                                                        </vs-collapse-item>
                                                    </vs-collapse>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>

                                    <!-- Sobre el Análisis financiero -->
                                    <div v-if="isMoral" class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="DollarSignIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Análisis Financiero</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <div v-for="section in getSectionsForGroup(group)" :key="section.data.id">
                                                    <div v-if="(section.data.id == 152)">
                                                        <div class="vx-row">
                                                            <template v-for="f in section.data.fields">
                                                                <!-- Campos automaticos -->
                                                                <form-field
                                                                    :ref="'section' + section.data.id"
                                                                    v-if="(isAutoFormField(f) && showInFinancialAnalysis(f.fname))"
                                                                    :key="f.id"
                                                                    :f="f"
                                                                    :keepDisabled="isDisabled"
                                                                    :dataContainer="getContainerForField(section, f)"
                                                                    :collectionsRoot="collections"
                                                                    :onChangeReceptor="onFieldChange"
                                                                    :hasBackofficeAccess="hasBackofficeAccess"
                                                                    :inputClassLarge="true"
                                                                    :evaluator="evaluateCondition" />
            
                                                            </template>
                                                        </div>
            
                                                            <!-- Save Button -->
                                                        <div class="vx-col w-full m-3" v-if="!isDisabled && !section.data.skipBtn">
                                                            <div class="flex flex-wrap items-center justify-end">
                                                                <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>
                                    
                                    <!-- factores de riesgo -->
                                    <div v-if="financeLoanData.risk_factors != null && (isMoral || applicantLoanData.tax_profile == 2)" class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="AlertCircleIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Factores de riesgo</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <ul class="list-bold" v-if="tr.risk_factors.length > 1" v-for="(tr, index) in financeLoanData.risk_factors " :key="index">
                                                    <li>
                                                        {{ tr.category }} <br>
                                                        <span :key="rindex" v-for="(risk, rindex) in tr.risk_factors">{{ risk.text }} <br></span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </vx-card>
                                    </div>
                                    
                                    <!-- Sobre las garantías -->
                                    <div class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="ShieldIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Instrumentación y ejecución de garantías</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <loan-guarantees-control
                                                    :projectId="currentProjectId"
                                                    :canEdit="false"
                                                    ></loan-guarantees-control>
                                            </div>
                                        </vx-card>
                                    </div>
                                </vs-tab>
                                <vs-tab label="Solicitante">
                                    <!-- Sobre el solicitante -->
                                    <div class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="SmileIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Sobre el solicitante</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <!-- PM -->
                                                <div v-if="isMoral" class="vx-row">
                                                    <!-- sólo lectura -->
                                                    <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                                                        <h5 class="dark-blue m-3">Solicitante PM</h5>
                                                        <ul class="list-bold ml-4">
                                                            <li>
                                                                Nombre comercial:
                                                                <span>{{ applicantLoanData.name }}</span>
                                                            </li>
                                                            <li>
                                                                Cantidad de créditos previos:
                                                                <span>{{ applicantLoanData.other_projects }}</span>
                                                            </li>
                                                            <li>
                                                                Giro del negocio:
                                                                <span>{{ applicantLoanData.business_activities }}</span>
                                                            </li>
                                                            <li>
                                                                Fecha de constitución: 
                                                                <span>{{applicantLoanData.constitution_date ? constitutionDateFormat(applicantLoanData.constitution_date) : "NA"}}</span>
                                                            </li>
                                                            <li>
                                                                Ubicación:
                                                                <span>{{ applicantLoanData.address }}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div v-if="applicantLoanData.guarantee" class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                                                        <h5 class="dark-blue m-3">Obligado solidario</h5>
                                                        <ul class="list-bold ml-4">
                                                            <li>
                                                                Relación con el solicitante: <span>{{ applicantLoanData.guarantee.relation_with_applicant }} </span>
                                                            </li>
                                                            <li>
                                                                Edad: <span>{{ applicantLoanData.guarantee.age }} años</span>
                                                            </li>
                                                            <li>
                                                                Género: <span>{{ applicantLoanData.guarantee.gender == "H" ? "Hombre" : "Mujer"}}</span>
                                                            </li>
                                                            <li>
                                                                Residencia: <span>{{ applicantLoanData.guarantee.address }}</span>
                                                            </li>
                                                            <li>
                                                                Educación: <span>{{ applicantLoanData.guarantee.education_level }}</span>
                                                            </li>
                                                            <li>
                                                                Experiencia personal o de negocios: <span>{{ applicantLoanData.guarantee.ocupation.name }}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <!-- editables -->
                                                    <div class="vx-col w-full">
                                                        <vs-divider></vs-divider>
                                                        <div v-for="section in getSectionsForGroup(group)" :key="section.data.id">
                                                            <div v-if="(section.data.id == 152)">
                                                                <div class="vx-row">
                                                                    <template v-for="f in section.data.fields">
                                                                        <!-- Campos automaticos -->
                                                                        <form-field
                                                                            :ref="'section' + section.data.id"
                                                                            v-if="(isAutoFormField(f) && showInPMApplicant(f.fname))"
                                                                            :key="f.id"
                                                                            :f="f"
                                                                            :keepDisabled="isDisabled"
                                                                            :dataContainer="getContainerForField(section, f)"
                                                                            :collectionsRoot="collections"
                                                                            :onChangeReceptor="onFieldChange"
                                                                            :hasBackofficeAccess="hasBackofficeAccess"
                                                                            :inputClassLarge="true"
                                                                            :evaluator="evaluateCondition" />
                
                                                                    </template>
                                                                </div>
                
                                                                <!-- Save Button -->
                                                                <div class="vx-col w-full m-3" v-if="!isDisabled && !section.data.skipBtn">
                                                                    <div class="flex flex-wrap items-center justify-end">
                                                                        <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="vx-col w-full">
                                                        <vs-divider></vs-divider>
                                                        <h6 class="mb-3">Documentos</h6>
                                                        <div class="vx-row">
                                                            <document-upload-lite
                                                            :accepts="['png','jpg','jpeg']"
                                                            upload-type="logo"
                                                            name="Logo"
                                                            :check-url="checkUrlLogo"
                                                            :view-url="viewUrlLogo"
                                                            :download-url="downloadUrlLogo"
                                                            :upload-url="uploadUrlLogo"
                                                            width="1/4"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- PF -->
                                                <div class="vx-row" v-else>
                                                    <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                                                        <h5 class="dark-blue m-3">Solicitante</h5>
                                                        <ul class="list-bold ml-3">
                                                            <li>
                                                                Edad: <span>{{ applicantLoanData.age }} años</span>
                                                            </li>
                                                            <li>
                                                                Género: <span>{{ applicantLoanData.gender == "H" ? "Hombre" : "Mujer"}}</span>
                                                            </li>
                                                            <li>
                                                                Residencia: <span>{{ applicantLoanData.address }}</span>
                                                            </li>
                                                            <li>
                                                                Educación: <span>{{ applicantLoanData.education_level }}</span>
                                                            </li>
                                                            <li>
                                                                Experiencia personal o de negocios: <span>{{ applicantLoanData.ocupation.name }}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                                                        <h5 class="dark-blue m-3">Capacidad de pago</h5>
                                                        <ul class="list-bold ml-3">
                                                            <li>
                                                                Ingresos estimados: <span>{{ applicantLoanData.payment_information != null ? explicitMoneyFormat(applicantLoanData.payment_information.average_amount) : "No definido" }} </span>
                                                            </li>
                                                            <li>
                                                                Fuentes de ingreso:
                                                                <span>
                                                                    <ul class="guarantees-list">
                                                                        <li v-for="incomeSource in applicantLoanData.payment_information.income_source_proofs">{{incomeSource.income_source_name}}.</li>
                                                                    </ul> 
                                                                </span>
                                                            </li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div v-if="applicantLoanData.guarantee" class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                                                        <h5 class="dark-blue m-3">Obligado solidario</h5>
                                                        <ul class="list-bold ml-4">
                                                            <li>
                                                                Relación con el solicitante: <span>{{ applicantLoanData.guarantee.relation_with_applicant }} </span>
                                                            </li>
                                                            <li>
                                                                Edad: <span>{{ applicantLoanData.guarantee.age }} años</span>
                                                            </li>
                                                            <li>
                                                                Género: <span>{{ applicantLoanData.guarantee.gender == "H" ? "Hombre" : "Mujer"}}</span>
                                                            </li>
                                                            <li>
                                                                Residencia: <span>{{ applicantLoanData.guarantee.address }}</span>
                                                            </li>
                                                            <li>
                                                                Educación: <span>{{ applicantLoanData.guarantee.education_level }}</span>
                                                            </li>
                                                            <li>
                                                                Experiencia personal o de negocios: <span>{{ applicantLoanData.guarantee.ocupation.name }}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>
                                </vs-tab>
                                <vs-tab label="Proyecto">
                                    <!-- Sobre el proyecto -->
                                    <div class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="TargetIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Sobre el proyecto</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <div class="mb-base" v-for="section in getSectionsForGroup(group)" :key="section.data.id">
                                                    <div v-if="section.data.id == 95">
                                                        <div class="vx-row">
                                                            <template v-for="f in section.data.fields">
                                                                <!-- Campos automaticos -->
                                                                <form-field
                                                                    :ref="'section' + section.data.id"
                                                                    v-if="(isAutoFormField(f) && showInProjectsInformation(f.fname))"
                                                                    :key="f.id"
                                                                    :f="f"
                                                                    :keepDisabled="isDisabled"
                                                                    :dataContainer="getContainerForField(section, f)"
                                                                    :collectionsRoot="collections"
                                                                    :onChangeReceptor="onFieldChange"
                                                                    :hasBackofficeAccess="hasBackofficeAccess"
                                                                    :inputClassLarge="true"
                                                                    :evaluator="evaluateCondition" />

                                                                    <div
                                                                        class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mb-5" 
                                                                        v-else-if="f.fname == 'project_category_theme_id'"
                                                                        >
                                                                        <div v-if="base.project_category_id == null">
                                                                            <vs-button @click.stop="popupActivo = true">Agregar línea de acción</vs-button>
                                                                        </div>
                                                                        <div v-else>
                                                                            <vs-button  class="float-right" size="small" @click.stop="popupActivo = true">Editar</vs-button>
                                                                            <h5 class="dark-blue m-3">Estrategía de sostenibilidad</h5> 
                                                                            <ul class="list-bold mb-2 pl-4">
                                                                                <li>Línea de acción: <span>{{ base.project_category.name || "-" }}</span> <br></li>
                                                                                <li>Giro: <span>{{ base.project_category_theme ? base.project_category_theme.name : "-"  }}</span> <br></li>
                                                                                <li v-if="base.project_category_theme_id != null">Tipo: <span>{{ base.project_category_theme_type ? base.project_category_theme_type.name : "--" }}</span> <br></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
            
                                                            </template>
                                                            <!-- Save Button -->
                                                            <div class="vx-col w-full m-3" v-if="!isDisabled && !section.data.skipBtn">
                                                                <div class="flex flex-wrap items-center justify-end">
                                                                    <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                                                                </div>
                                                            </div>
                                                            <div class="vx-col w-full">
                                                                <vs-collapse>
                                                                    <vs-collapse-item>
                                                                        <div class="black" slot="header">
                                                                            Uso general de los recursos
                                                                        </div>
                                                                        <resources-destination-control
                                                                            :projectId="currentProjectId" />
                                                                    </vs-collapse-item>
                                                                    <vs-collapse-item>
                                                                        <div class="black" slot="header">
                                                                            Otros documentos
                                                                        </div>
                                                                        <extra-project-documentation
                                                                            :projectId="currentProjectId"
                                                                            ></extra-project-documentation>
                                                                    </vs-collapse-item>
                                                                    <vs-collapse-item v-if="isMoral">
                                                                        <div class="black" slot="header">
                                                                            Imágenes de la empresa
                                                                        </div>
                                                                        <business-profile-images-control 
                                                                            :userId="base.client.user_id"
                                                                            :projectId="currentProjectId"
                                                                            :businessProfileId="base.client.user.business_profile_id"
                                                                            />
                                                                    </vs-collapse-item>
                                                                    <vs-collapse-item v-if="isMoral">
                                                                        <div class="black" slot="header">
                                                                            Lista de inmuebles
                                                                        </div>
                                                                            <real-state-list
                                                                                :locations="locations"
                                                                                ></real-state-list>
                                                                    </vs-collapse-item>
                                                                </vs-collapse>
                                                            </div>

                                                            <div class="vx-col w-full">
                                                                <vs-divider></vs-divider>
                                                                <h6 class="mb-3">Documentos</h6>
                                                                <div class="vx-row">
                                                                    <document-upload-lite
                                                                        :accepts="['png','jpg','jpeg']"
                                                                        upload-type="public_cover_image"
                                                                        name="Portada de proyecto"
                                                                        :check-url="checkUrl"
                                                                        :view-url="viewUrl"
                                                                        :download-url="downloadUrl"
                                                                        :upload-url="uploadUrl"
                                                                        width="1/4"
                                                                        />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>

                                     <!-- sobre las promociones -->
                                     <div class="vx-col w-full mb-base">
                                        <vx-card>
                                            <div class="flex ml-3">
                                                <feather-icon icon="FlagIcon"
                                                    svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                <h3 class="dark-blue m-3">Promociones</h3>
                                            </div>
                                            <div class="vx-col w-full">
                                                <div v-for="section in getSectionsForGroup(group)" :key="section.data.id">
                                                    <div v-if="(section.data.id == 95)">
                                                        <div class="vx-row">
                                                            <template v-for="f in section.data.fields">
                                                                <!-- Campos automaticos -->
                                                                <form-field
                                                                    :ref="'section' + section.data.id"
                                                                    v-if="(isAutoFormField(f) && showInPromotion(f.fname))"
                                                                    :key="f.id"
                                                                    :f="f"
                                                                    :keepDisabled="isDisabled"
                                                                    :dataContainer="getContainerForField(section, f)"
                                                                    :collectionsRoot="collections"
                                                                    :onChangeReceptor="onFieldChange"
                                                                    :hasBackofficeAccess="hasBackofficeAccess"
                                                                    :inputClassLarge="true"
                                                                    :evaluator="evaluateCondition" />
            
                                                            </template>
                                                        </div>
            
                                                            <!-- Save Button -->
                                                        <div class="vx-col w-full m-3" v-if="!isDisabled && !section.data.skipBtn">
                                                            <div class="flex flex-wrap items-center justify-end">
                                                                <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                                                            </div>
                                                        </div>

                                                        <div class="vx-col w-full">
                                                            <vs-divider></vs-divider>
                                                            <h6 class="mb-3">Documentos</h6>
                                                            <div class="vx-row">
                                                                <document-upload-lite
                                                                :accepts="['png','jpg','jpeg']"
                                                                upload-type="promo-cover"
                                                                name="Imagen de la promoción"
                                                                :check-url="checkPromoUrl"
                                                                :view-url="viewPromoUrl"
                                                                :download-url="downloadPromoUrl"
                                                                :upload-url="uploadPromoUrl"
                                                                width="1/4"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>
                                    
                                    <!-- PROVEEDOR Y TECNOLOGÍAS -->
                                    <div class="vx-row" v-if="financeLoanData.loan_type == 1" >
                                        <!-- sobre las proveedor -->
                                        <div class="vx-col w-full mb-base">
                                            <vx-card>
                                                <div class="flex ml-3">
                                                    <feather-icon icon="UsersIcon" svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                    <h3 class="dark-blue m-3">Sobre el proveedor</h3>
                                                </div>
                                                <div class="vx-row m-5">
                                            <!-- resumen -->
                                                    <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-2">
                                                        <div class="con-example-images mb-2">
                                                            <img v-if="supplierLogoUrl != undefined" class="fix-logo-supplier" :src="supplierLogoUrl" alt="Logo_proveedor">
                                                            <img v-else src="https://cdn.redgirasol.com/green/perfiles/hombre.jpg" class="fix-logo-supplier" alt="Logo_proveedor">
                                                        </div>
                                                    </div>
                                                    <div class="vx-col sm:w-full md:w-2/3 lg:w-2/3 mb-2">
                                                        <ul class="list-bold mb-2">
                                                            <li>
                                                                {{publicProjectData.installer.tradename}}<span></span>
                                                            </li>
                                                            <li>
                                                                <span>{{ publicProjectData.installer.extra_info }}</span>
                                                            </li>
                                                            <li>
                                                                Proyectos fondeados: <span>{{ supplierDuePortfolio.projects_funded_number }}</span>
                                                            </li>
                                                            <li>
                                                                Proyectos vencidos: <span>{{ supplierDuePortfolio.projects_funded_fall_due_number }}</span>
                                                            </li>
                                                            <li>
                                                                Monto financiado: <span>{{ explicitMoneyFormat(supplierDuePortfolio.projects_funded_amount) }}</span>
                                                            </li>
                                                        </ul>
                                                        <div class="flex">
                                                            <a
                                                                v-if="webpageUrl"
                                                                :href="$sanitizeUrl(webpageUrl)"
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                <feather-icon icon="GlobeIcon" class=" text-dark" />
                                                            </a>
                                                            <a
                                                                v-if="facebookUrl"
                                                                :href="$sanitizeUrl(facebookUrl)"
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                <feather-icon icon="FacebookIcon" class="inline-social-icon text-dark" />
                                                            </a>
                                                            <a
                                                                v-if="twitterUrl"
                                                                :href="$sanitizeUrl(twitterUrl)"
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                <feather-icon icon="TwitterIcon" class="inline-social-icon text-dark" />
                                                            </a>
                                                            <a
                                                                v-if="instagramUrl"
                                                                :href="$sanitizeUrl(instagramUrl)"
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                <feather-icon icon="InstagramIcon" class="inline-social-icon text-dark" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </vx-card>
                                        </div>

                                        <!-- sobre la tecnología -->
                                        <div class="vx-col w-full mb-base">
                                            <vx-card>
                                                <div class="flex ml-3">
                                                    <feather-icon icon="CpuIcon" svgClasses="w-5 h-5 text-primary stroke-current bold mt-4" />
                                                    <h3 class="dark-blue m-3">Tecnologías</h3>
                                                </div>
                                                <div class="vx-row m-5">
                                                    <div v-for="pg_request in financeLoanData.pg_requests" class="vx-col w-full mb-base">

                                                        <ul class="list-bold mb-2">
                                                            <li>
                                                                {{ pg_request.family_group.name }}<span></span>
                                                            </li>
                                                        </ul>

                                                        <vs-table id="guarantee-table" :data="pg_request.pg_requests" stripe noDataText="No hay registros disponibles">
                                                            <template slot="thead">
                                                                <vs-th class="bold" v-for="(col, idx) in columnsTechnology" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                                            </template>

                                                            <template slot-scope="{data}">
                                                                <tbody>
                                                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                                                        <vs-td>
                                                                            {{tr.product_model.product_brand.product_group.name}}
                                                                        </vs-td>
                                                                        <vs-td>
                                                                            {{tr.product_model.product_brand.brand}}
                                                                        </vs-td>
                                                                        <vs-td>
                                                                            {{tr.product_model.model}}
                                                                        </vs-td>
                                                                        <vs-td>
                                                                            {{tr.product_model.capacity + tr.product_model.product_brand.product_group.capacity_units}}
                                                                        </vs-td>
                                                                        <vs-td>
                                                                            {{tr.quantity}}
                                                                        </vs-td>
                                                                        
                                                                    </vs-tr>
                                                                </tbody>
                                                            </template>
                                                        </vs-table>
                                                    </div>
                                                </div>
                                            </vx-card>
                                        </div>
                                    </div>
                                </vs-tab>
                            </vs-tabs>
                        </div>
                    </vx-card>
                </div>
            </vs-tab>

        </vs-tabs>

        <load-error v-if="failed" />

            <!-- MODAL LÍNEA DE ACCIÓN -->
            <vs-popup class="mid-popup header-primary" title="Agregar línea de acción" :active.sync="popupActivo">
                <h3>Línea de acción.</h3>
                <p>Selecciona el giro y tipo que corresponda a la linea de acción en la que impacta el crédito <strong>{{ base.id }} | {{ base.alias }}</strong>. El campo <strong>Tipo</strong> puede quedarse vacío.</p>
                <div class="vx-row mb-base">
                    <div class="vx-col sm:w-full md:w-1/2 lg:w-1/2">
                        <label class="bold mt-3">Giro</label>
                        <vs-select
                            class="w-full"
                            v-model.lazy="themeSelected"
                            name="eventSelected"
                            placeholder="Seleccione una opción">
                        
                            <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item.select_name"
                            v-for="(item, index) in collections.project_category_themes"
                            class="w-full"
                            />
                        </vs-select>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2 lg:w-1/2">
                        <label class="bold mt-3">Tipo</label>
                        <vs-button v-if="!isNew" class="float-right" type="line" size="small" @click.stop="isNew = true">Agregar nuevo</vs-button>
                        <vs-button v-else class="float-right" type="line" size="small" @click.stop="isNew = false, themeTypeSelectedNew = null">Seleccionar existente</vs-button>
                        <div v-if="!isNew">
                            <vs-select
                                class="w-full"
                                v-model.lazy="themeTypeSelected"
                                name="eventSelected"
                                placeholder="Seleccione una opción">
                            
                                <vs-select-item
                                :key="index"
                                :value="item"
                                :text="item.select_name"
                                v-for="(item, index) in getThemeTypes()"
                                class="w-full"
                                />
                            </vs-select>
                        </div>
                        <div v-else class="w-full">
                            <vs-input class="w-full" type="text" v-model="themeTypeSelectedNew"/>
                        </div>
                    </div>
                </div>

                <div class="vx-row justify-content-end">
                    <div class="vx-col">
                        <vs-button @click.stop="postActionLines()" class="mr-4">Aceptar</vs-button>
                        <vs-button @click.stop="resetLineActionForm()" color="dark">Cancelar</vs-button>
                    </div>
                </div>
            </vs-popup>

    </div>
</template>
  
<script>
import inputHelper from '@components/mixins/inputHelper';
import dateHelper from '@components/mixins/dateHelper';
import formHelper from '@components/mixins/formHelper';
import formatHelper from '@components/mixins/formatHelper';
import FormField from '@components/forms/FormField.vue';
import ResourcesDestinationControl from './resourcesDestination/ResourcesDestinationControl.vue';
import LoanGuaranteesControl from './loanGuarantees/LoanGuaranteesControl.vue';
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import BusinessProfileImagesControl from './BusinessProfileImagesControl.vue';
import ExtraProjectDocumentation from './extraProjectDocumentation/ExtraProjectDocumentation.vue';
import RealStateList from './technologies/RealStateList.vue'

const httpPattern = /^http[s]*:\/\/[\w]+/i;

const columns = [
    { title: "MES", key: "month", sortable: true }
    , { title: "FECHA DE PAGO", key: "payment_date", sortable: true }
    , { title: "PAGO", key: "payment", sortable: true }
    , { title: "SALDO INICIAL", key: "initial_debt", sortable: false }
    , { title: "AMORTIZACIÓN", key: "amortization", sortable: false }
    , { title: "INTERESES", key: "interest", sortable: false }
    , { title: "IVA", key: "tax", sortable: false }
    , { title: "SALDO FINAL", key: "final_debt", sortable: false }
];

const columnsTechnology = [
    { title: "PRODUCTO", key: "product", sortable: true }
    , { title: "MARCA", key: "brand", sortable: true }
    , { title: "MODELO", key: "model", sortable: true }
    , { title: "CAPACIDAD", key: "capacity", sortable: false }
    , { title: "CANTIDAD", key: "quantity", sortable: false }
];

const tabsDefs = [
    { slug: "publication", title: "Datos para publicación", icon: "icon-user", sections: [95, 96] },
];

const tabsPMDefs = [
    { slug: "publication", title: "Datos para publicación", icon: "icon-user", sections: [95, 96, 152] },
];

const sectionsToContainers = [
    {
        id: 95, containers: [
            { db: 'projects', path: 'base' },
            { db: 'project_finances', path: 'finance' }
        ]
    },
    {
        id: 96, containers: [
            { db: 'suppliers', path: 'supplier' },
            { db: 'none', path: 'base' },
            { db: 'computed', path: 'calculations' },
        ]
    },
    {
        id: 152, containers: [
            { db: 'business_profiles', path: 'client.user.business' }
        ]
    }
];

const requiredObjects = [
    'finance',
    'supplier.user',
    'splits',
    'client.user.business'
];

const appendObjects = [
    'subcategory'
];

const arrayPaths = [];

export default {
    mixins: [formHelper, inputHelper, dateHelper, formatHelper],
    props: ['id', "isDisabled", "person_type"],
    data() {
        return {
            columns: columns,
            columnsTechnology: columnsTechnology,
            errorCode: 0,
            onError: false,

            pmClientType: 0,
            pfClientType: 1,

            form_id: 45,

            isMaster: null,

            loading: false,
            isMounted: false,
            isRefreshing: false,
            errorMssg: '',
            successMssg: '',
            failed: false,

            flow: {},
            allSections: [],
            sectionGroups: [],

            documentsStates: [],

            tabs: tabsDefs,

            isMoral: false,
            isPfae: false,
            activeTab: 0,
            activeTab1: 0,

            collections: {
                terms: [],
                cover_images: [],
                project_types: [],
                project_type_subcategories: [],
                project_categories: [],
                project_category_themes: [],
                project_category_theme_types: []
            },

            // objeto principal
            base: {},

            // auxiliares para evaluacion de condiciones
            mexicoCountryId: 700,

            // objetos para actualizaciones
            basePayload: {},
            validatedFields: [],
            currentSupplierUserId: null,

            calculations: {
                monto_fondeado: 0,
                avance_fondeo: 0,
                num_inversionistas: 0,
                participacion_rg: 0,
                garantia: null,
                ahorro_mensual: null,
                cobertura: null,
                inversion: null,
                beneficio: null,
            },

            locations: [],
            financeLoanData: null,
            publicProjectData: null,
            applicantLoanData: null,
            supplierInfo: null,
            supplierInfoDuePortfolio: {
                projects_funded_number: 0,
                projects_funded_fall_due_number: 0,
                projects_funded_amount: 0
            },
            supplierLogoUrl: null,
            canAskForRefund: null,
            popupActivo: false,
            themeSelected: null,
            themeTypeSelected: null,
            isNew: false,
            themeTypeSelectedNew: null
        }
    },
    components: {
        FormField,
        ResourcesDestinationControl,
        DocumentUploadLite,
        LoanGuaranteesControl,
        BusinessProfileImagesControl,
        ExtraProjectDocumentation,
        RealStateList
    },
    computed: {
        checkUrl() {
            if (this.currentProjectId) {
                return `project/${this.currentProjectId}/cover/info`;
            }
            return null;
        },
        viewUrl() {
            if (this.currentProjectId) {
                return `project/${this.currentProjectId}/cover/view`;
            }
            return null;
        },
        downloadUrl() {
            if (this.currentProjectId) {
                return `project/${this.currentProjectId}/cover/download`;
            }
            return null;
        },
        uploadUrl() {
            if (this.currentProjectId) {
                return `project/${this.currentProjectId}/cover/upload`;
            }
            return null;
        },
        checkUrlLogo() {
            if (this.currentProjectId) {
                return `business-profile/${this.currentProjectId}/logo/info`;
            }
            return null;
        },
        viewUrlLogo() {
            if (this.currentProjectId) {
                return `business-profile/${this.currentProjectId}/logo/view`;
            }
            return null;
        },
        downloadUrlLogo() {
            if (this.currentProjectId) {
                return `business-profile/${this.currentProjectId}/logo/download`;
            }
            return null;
        },
        uploadUrlLogo() {
            if (this.currentProjectId) {
                return `business-profile/${this.currentProjectId}/logo/upload`;
            }
            return null;
        },
        checkPromoUrl() {
            if (this.id) {
                return `project/${this.id}/promo/info`;
            }
            return null;
        },
        viewPromoUrl() {
            if (this.id) {
                return `project/${this.id}/promo/view`;
            }
            return null;
        },
        downloadPromoUrl() {
            if (this.id) {
                return `project/${this.id}/promo/download`;
            }
            return null;
        },
        uploadPromoUrl() {
            if (this.id) {
                return `project/${this.id}/promo/upload`;
            }
            return null;
        }, 
        hasBackofficeAccess() {
            return this.$acl.check('isBackoffice');
        },
        isSmallerScreen() {
            return this.$store.state.windowWidth < 2000
        },
        currentProjectId() {
            return this.id;
        },
        currentClientUserId() {
            return this.base.client_id;
        },
        facebookUrl(){
            return this.formatUrl(this.publicProjectData.installer.facebook);
        },
        webpageUrl(){
            return this.formatUrl(this.publicProjectData.installer.webpage);
        },
        twitterUrl(){
            return this.formatUrl(this.publicProjectData.installer.twitter);
        },
        instagramUrl(){
            return this.formatUrl(this.publicProjectData.installer.instagram);
        },
        supplierDuePortfolio(){
            let supplierDuePortfolioObj = this.supplierInfo.duePortafolio[0];
            if (supplierDuePortfolioObj) {
                this.supplierInfoDuePortfolio.projects_funded_number = supplierDuePortfolioObj.projects_funded_number;
                this.supplierInfoDuePortfolio.projects_funded_fall_due_number = supplierDuePortfolioObj.projects_funded_fall_due_number;
                this.supplierInfoDuePortfolio.projects_funded_amount = supplierDuePortfolioObj.projects_funded_amount;                
            }
            return this.supplierInfoDuePortfolio;
        }
    },
    async mounted() {
        this.loading = true;
        this.isMounted = false;
        await this.getCollections();
        await this.getProjectData();
        this.setSupplierUserId();
        this.setClientPersonTypeInfo();
        await this.setCustomIntegrations();
        await this.getFormInfo();
        this.setSectionGroups();
        await this.getSpecialCalculations();

        // NUEVOS CAMPOS
        await this.getFinanceLoanData();
        await this.getPublicProjectData();
        await this.getApplicantLoanData();
        await this.getSupplierInfo();

        this.getLocationLists();
        this.isMounted = true;
        this.loading = false;
    },
    watch: {
        loading: function (newVal, oldVal) {
            if (newVal === true) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        async getLocationLists() {
            try {
                const res = await axios.get(`/api/get/fg_locations/type-name/${this.currentProjectId}`);
                this.locations = res.data;
            } catch (error) {

            }
        },
        translateType(status) {
            if (status == "home") {
                return "Casa particular";
            } else if (status == "business") {
                return "Negocio";
            } else {
                return "Casa con negocio";
            }
        },
        setSupplierUserId(){
            this.currentSupplierUserId = this.base.supplier != null ? this.base.supplier.user_id : null;
        },
        getSectionGroups() {
            return this.sectionGroups;
        },
        getSectionsForGroup(group) {
            return group.sections.filter(f => f.data.fields.length > 0);
        },
        async reloadFormInfo() {
            this.isRefreshing = true;
            await this.getProjectData();
            await this.setCustomIntegrations();
            this.reloadSectionGroups();
            this.set_social_network_object();
            this.isRefreshing = false;
        },
        async saveGroupChanges(section) {
            let result = await this.runValidations(section);
            if (!result) {
                this.missingFieldsNotif();
            }
            else {
                this.loading = true;

                //guardar solo la informacion que se ha modificado
                this.basePayload = this.collectFormData(section);

                // conversion de finance.deposit_percentage
                let finance = this.basePayload.finance;
                if (finance && finance.annual_interest_percentage != null) {
                    finance.annual_interest_percentage_unit = this.decimalsFormat(finance.annual_interest_percentage * 100, 2);
                }

                if (this.objectIsEmpty(this.basePayload)) {
                    //this.notFieldsToUpdate();
                    this.saveSuccessNotif();
                    this.loading = false;
                    return;
                }

                this.basePayload.id = this.base.id;

                try {
                    // ejecutar guardado
                    const res = await axios.put(`/api/v2/projects/${this.currentProjectId}/deepUpdate`, this.basePayload);

                    // if (res.satus == 423) {
                    //     this.failedOperationNotif(null, "CURP o RFC duplicados.");
                    // }
                    // solicitar la informacion actualizada del modelo
                    await this.reloadFormInfo();

                    this.saveSuccessNotif();
                }
                catch (error) {
                    this.failedOperationNotif(null, null);
                }

                this.loading = false;
            }
        },
        async runValidations(section) {
            // validar componentes tipo FormField
            let gslug = "section" + section.data.id;
            let res1 = await this.validateFormFields(gslug);
            if (!res1) {
                return false;
            }

            // validar inputs instanciados en la vista
            let res2 = await this.$validator.validateAll();
            if (!res2) {
                return false;
            }

            // inspeccionar los campos para ejecutar validaciones especiales
            let spValidation = await this.checkFormFieldsSpecialValidations(gslug);
            if (!spValidation) {
                return false;
            }

            // inspeccionar los campos agregados directo en el componente para ejecutar validaciones especiales

            let sp_failed = false;

            section.data.fields.filter(f => f.special_definition === 1).forEach(f => {
                // considerar los campos habilitados (visibles), con validaciones especiales
                if (this.fields[f.fname] && f.special_validation !== null && f.special_validation.method !== null) {
                    let res = this[f.special_validation.method]();

                    if (!res) {
                        this.errors.add({
                            field: f.fname,
                            msg: f.special_validation.error
                        });
                        this.missingFieldsNotif(f.field_name, f.special_validation.error, 10000);
                        sp_failed = true;
                    }
                }
            });

            if (sp_failed) {
                return false;
            }

            // retornar true si todas las validaciones fueron positivas
            return true;
        },
        collectFormData(section) {
            let payload = {};
            section.containers.forEach(cc => {
                let fields = this.validatedFields.filter(vf => vf.db === cc.db);
                if (fields.length < 1) {
                    return;
                }

                if (cc.path === "base") {
                    fields.forEach(f => {
                        payload[f.fname] = cc.container[f.fname];
                    });
                }
                else {
                    let obj = null;
                    if (arrayPaths.includes(cc.path)) {
                        // se integran todos los objetos de la coleccion
                        obj = this.nestedFieldValue(this.base, cc.path);
                    }
                    else {
                        obj = { id: cc.container.id };
                        fields.forEach(f => {
                            obj[f.fname] = cc.container[f.fname];
                        });
                    }
                    // ajuste para objetos tipo array
                    this.setNestedObjectWithIds(payload, this.base, cc.path, obj);
                }
            });
            return payload;
        },
        async validateFormFields(refGroup) {
            let allValid = true;
            this.validatedFields = [];
            let grefs = this.$refs[refGroup];
            for (let p in grefs) {
                let r = await this.$refs[refGroup][p].checkForValidDirty();
                if (r.valid == false) {
                    allValid = false;
                }
                else if (r.dirty == true) {
                    this.validatedFields.push(r);
                }
            }
            return allValid;
        },
        async checkFormFieldsSpecialValidations(refGroup) {
            let spvalid = true;
            let grefs = this.$refs[refGroup];
            let f;
            for (let p in grefs) {
                f = grefs[p];
                let sp = f.specialValidation();
                if (sp != null) {
                    let res = await this[sp.method]();
                    let n = f.rawFieldName;
                    if (!res) {
                        spvalid = false;
                        f.setError(sp.error);
                        this.errorNotif(n, sp.error, 10000);
                    }
                }
            }
            return spvalid;
        },
        async onFieldChange(method) {
            if (method != null && method in this) {
                await this[method]();
            }
        },
        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },

        /* obtener ids para los casos correspondientes */
        docTargetEvaluator(cls, cls_2) {
            if (cls === 'user') {
                if (cls_2 === 'supplier') {
                    return this.currentSupplierUserId;
                }
                else if (cls_2 === 'applicant') {
                    return this.base.client.user.id;
                }
            }
            else if (cls === 'project') {
                return this.currentProjectId;
            }
            this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
            return null;
        },

        setClientPersonTypeInfo() {
            this.isMoral = this.person_type === this.pmClientType;
            this.isPfae = this.person_type === this.pfClientType;

            this.tabs = this.isMoral ? tabsPMDefs : tabsDefs;
        },
        async setCustomIntegrations() {
            let finance = this.base.finance;
            if (finance && finance.annual_interest_percentage != null) {
                finance.annual_interest_percentage_unit = this.decimalsFormat(finance.annual_interest_percentage * 100, 2);
            }
        },
        setSectionGroups() {
            this.tabs.forEach(t => {
                let group = { title: t.title, icon: t.icon, slug: t.slug }; //, vModel: this.getModelForGroup(t.slug) };
                let sections = [];

                t.sections.forEach(ss => {
                    let s = this.allSections.find(f => f.id === ss);
                    if (s != null) {
                        let sb = { data: s, containers: this.getContainersForSection(s.id) };
                        sections.push(sb);
                    }
                    else {
                        this.warn("Section " + ss + " not found");
                    }
                })
                group.sections = sections;
                this.sectionGroups.push(group);
            });
        },
        reloadSectionGroups() {
            this.sectionGroups.forEach(group => {
                group.sections.forEach(s => {
                    s.containers = this.getContainersForSection(s.data.id);
                })
            });
        },
        getContainerForField(section, f) {
            if (f.db_table === 'computed') {
                return this.calculations;
            }

            let c = section.containers.find(sc => sc.db === f.db_table);
            if (!c) {
                this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
                return null;
            }
            else {
                return c.container;
            }
        },
        getContainersForSection(section_id) {
            let c = sectionsToContainers.find(f => f.id === section_id);
            if (!c) {
                this.warn("Missing containers definition for section " + section_id);
                return null;
            }
            else {
                let sectionContainers = [];
                c.containers.forEach(cc => {
                    let con = this.setContainerFromDef(cc);
                    sectionContainers.push({ db: cc.db, path: cc.path, container: con });
                })
                return sectionContainers;
            }
        },
        setContainerFromDef(c) {
            let container = this.nestedFieldValue(this.base, c.path);
            if (Array.isArray(container)) {
                let ac = null;
                if (c.arrayDefs) {
                    if (c.arrayDefs.getFirst === true) {
                        ac = container[0];
                    }
                    else if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval](container);
                    }
                }
                if (!ac) {
                    if (c.arrayDefs.onNull) {
                        if (c.arrayDefs.onNull in this) {
                            ac = this[c.arrayDefs.onNull]();
                        }
                        else {
                            this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.arrayDefs.onNull);
                        }
                    }
                    else { ac = {} }
                    container.push(ac);
                }
                return ac;
            }
            else {
                if (!container && c.objDefs && c.objDefs.onNull) {
                    if (c.objDefs.onNull in this) {
                        container = this[c.objDefs.onNull]();
                    }
                    else {
                        this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.objDefs.onNull);
                    }
                }
                if (!container) {
                    container = {};
                }
                return container;
            }
        },
        async getProjectData() {
            try {
                // ?filter[status]=3 // ejemplo de filtro
                let appends = "&append[]=" + appendObjects.join("&append[]=");
                let params = "with[]=" + requiredObjects.join("&with[]=");
                let response = await axios.get(`/api/v2/projects/${this.currentProjectId}?${params}${appends}`);
                this.base = response.data;
                this.isMaster = this.base.splits.length > 0;
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getFormInfo() {
            try {
                let id = this.form_id;
                let response = await axios.get("/api/v1/forms/getFormFields/" + id);
                let url = this.ApiDomain + `/storagev3/documents/form/${id}`;
                let response2 = await axios.get(url);
                this.documentsStates = response2.data;

                this.flow = response.data.flow;
                this.allSections = response.data.sections;

                this.allSections.forEach(s => {
                    if (this.tabs.filter(tt => tt.sections.includes(s.id)).length < 1) {
                        return;
                    }

                    s.documentFields = [];
                    let co = 0;
                    s.fields.forEach(f => {
                        this.formFieldSetter(f, this);
                        if (this.isAutoFieldToSave(f)) { co += 1 }
                        // check for documents
                        if (f.doc_id != null) {
                            let ff = { formField: f, documentSet: null, target_id: null };
                            let ss = this.documentsStates.find(sid => sid.id === s.id);
                            if (ss && ss.documents) {
                                let dset = ss.documents.find(d => d.id === f.doc_id);
                                if (dset) {
                                    ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                                    ff.documentSet = dset;
                                }
                            }
                            s.documentFields.push(ff);
                        }
                    });

                    if (co === 0) {
                        s.skipBtn = true;
                    }
                });
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getCollections() {
            try {
                let collectionsObjects = ['projectValidTerms', 'projectTypeSubcategories', 'projectTypes', 'getProjectCategoriesList', 'getProjectCategoryThemesList', 'getProjectCategoryThemeTypesList'];

                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                this.collections.terms = res.data.projectValidTerms;
                this.collections.cover_images = res.data.coverImagesList;
                this.collections.project_types = res.data.projectTypes;
                this.collections.project_type_subcategories = res.data.projectTypeSubcategories;
                this.collections.project_categories = res.data.getProjectCategoriesList;
                this.collections.project_category_theme_types = res.data.getProjectCategoryThemeTypesList;
                this.collections.project_category_themes = res.data.getProjectCategoryThemesList;
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        processError(code) {
            this.onError = true;
            this.errorCode = code;
        },

        async getSpecialCalculations() {
            try {
                const response = await axios.get(`/api/projects/single/${this.currentProjectId}`);
                const project = response.data.project;
                const finance = response.data.finance;

                this.calculations.monto_fondeado = project.invested;
                this.calculations.avance_fondeo = project.invested / (finance.financed_amount);
                this.calculations.num_inversionistas = project.inversionistas;
                this.calculations.participacion_rg = project.rg_participation;
                this.calculations.garantia = `${(finance.total_cost / finance.financed_amount).toFixed(2)} a 1`;
                this.calculations.ahorro_mensual = project.saving_per_year / 12;
                this.calculations.cobertura = project.saving_per_year / (finance.monthly_payment * 12);
                this.calculations.inversion = `$1 MXN = ${project.investment_environmental_impact.toFixed(2)} kgCO•2`;
                this.calculations.beneficio = `${(project.environmental_impact / 1000).toFixed(2)} TonCO•2`;
                this.calculations.environmental_impact = `${finance.environmental_impact !== null ? finance.environmental_impact : 0} kgCO•2`;
                this.calculations.economic_impact = `$${this.format_price(finance.economic_impact)}`;
            } catch (error) {
                this.warn(error);
                this.failedOperationNotif("Error inesperado", `Contacte a soporte técnico. Error: ${error.message}`);
            }

        },

        set_fiscal_business_type() {
            if (this.base.client.user.business.fiscal_business_type !== null) {
                const businessType = {
                    "sacv": 1
                    , "sapi": 2
                    , "scoop": 3
                    , "scivil": 4
                    , "ac": 5
                    , "abp": 6
                    , "srlcv": 7
                    , "sprrlcv": 8
                };
                this.base.client.user.business.fiscal_business_type = (businessType[this.base.client.user.business.fiscal_business_type] || null);
            }

            return null;
        },
        set_social_network_object() {
            try {
                if(this.isMoral) {
                    if (this.base.client.user.business.social_networks != null) {
                        let aux = JSON.parse(this.base.client.user.business.social_networks);
                        this.base.client.user.business.social_networks = aux.join();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        async getFinanceLoanData() {
            try {
                const res = await axios.get(`api/get/about-finance/${this.currentProjectId}`);
                this.financeLoanData = res.data;
            }
            catch (e) {
                this.warn(e);
            }
        },
        async getPublicProjectData(){
            try {
                const res = await axios.get(`api/projects/single/${this.currentProjectId}`);
                this.publicProjectData = res.data;
            } catch (error) {
                this.warn(e);
            }
        },
        async getApplicantLoanData() {
            try {
                const res = await axios.get(`api/get/about-applicant/${this.currentProjectId}`);
                this.applicantLoanData = res.data;
            }
            catch (e) {
                this.warn(e);
            }
        },
        async getSupplierInfo(){
            try {
                const res = await axios.get(`api/v2/investor/${this.InvestorId}/getProjectInstallerInfo/${this.id}`);
                this.supplierInfo = res.data.projectsInfo;
            }
            catch (e) {
            }
        },
        translateCrowdfundingLoanType(type) {
            const loanTypes = {
                1: "Préstamo personal"
                , 2: "Préstamo empresarial"
            };

            return loanTypes[type] || "NA";
        },
        translateLoanType(type) {
            const loanTypes = {
                1: "Crédito Verde"
                , 2: "Crédito para minado BTC"
                , 3: "Capital de trabajo"
                , 4: "Disposición de efectivo"
            };

            return loanTypes[type] || "NA";
        },
        translateGuaranteeType(type) {
            const loanTypes = {
                "real_real_state": "Bien inmueble"
                , "real_property": "Bien mueble"
                , "real_accounts_receivable": "Cuentas por cobrar"
                , "personal_jointly_bound": "Obligado Solidario"
            };

            return loanTypes[type] || "NA";
        },
        showInProjectsInformation(fname) {
            return fname == "alias" 
                    || fname == "project_category_id"
                    || fname == "investment_opportunities"
                    || fname == "investment_opportunities"
                    || fname == "webinar"
                    || fname == "pitch_file"
                    || fname == "description"
                    || fname == "minimal_investment"
                    || fname == "project_category_theme_id"
                    || fname == "project_category_theme_type_id"
                    || fname == "business_alliance"
        },
        showInPMApplicant(fname) {
            return fname == "fiscal_business_type" 
                    || fname == "institutional_video"
                    || fname == "website"
                    || fname == "social_networks"
                    || fname == "business_model"
                    || fname == "distribution_channels"
                    || fname == "team_experience"
                    || fname == "startup"
                    || fname == "business_accelerator"
        },
        showInFinancialAnalysis(fname) {
            return fname == "financial_performance" 
                    || fname == "financial_indicators"
        },
        showInPromotion(fname) {
            return fname == "promotion_title" 
                    || fname == "promo_link"
                    || fname == "promo_description"
        },
        formatUrl(url){
            if(!url){
                return null;
            }

            if(!httpPattern.exec(url)){
                return "https://" + url;
            }
            else{
                return url;
            }
        },
        getThemeTypes(){
            if(this.themeSelected){
                const res = this.collections.project_category_theme_types.filter(f => f.project_category_theme_id == this.themeSelected.id);
                return res;
            }
            return [];
        },
        async postActionLines() {
            try {
                this.showLoading(true);
                if(!this.validateLineActionForm()) {
                    this.showLoading(false);
                    return false;
                }

                const payload = {
                    is_new: this.isNew,
                    project_id: this.currentProjectId,
                    theme_id: this.themeSelected.id,
                    project_category_id: this.themeSelected.project_category_id,
                    new_theme_type_name: this.themeTypeSelectedNew,
                    project_category_theme_type_id: this.themeTypeSelected ? this.themeTypeSelected.id : null
                }

                await axios.post(`/api/post/project/${this.currentProjectId}/create-action-lines`, payload);
                this.successNotif(null, "Se ha guardado correctamente la línea de acción.");
                this.resetLineActionForm();
                await this.getCollections();
                await this.getProjectData();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                console.log(error);
                this.failedOperationNotif();
            }
        },
        validateLineActionForm()
        {
            let flag = true;
            // Sí es nuevo
            if(this.isNew) {
                // Evalua que el nombre de la linea de acción no esté vacío.
                if(this.themeTypeSelectedNew == null || this.themeTypeSelectedNew == ""){
                    this.missingFieldsNotif(null, "No puede estar vacío el nombre del nuevo tipo.");
                    flag = false;
                }
            }

            // En cualquier caso, tiene que validar que giro no esté vacío.
            if(this.themeSelected == null){
                this.missingFieldsNotif(null, "Para continuar, el giro no puede estar vacío.");
                flag = false;
            }
            
            return flag;
        },
        resetLineActionForm() {
            this.popupActivo = false;
            this.themeSelected = null;
            this.themeTypeSelected = null;
            this.isNew = false;
            this.themeTypeSelectedNew = null;
        }
    },

}
</script>
<style>
.list-bold {
    font-weight: bold;
    line-height: 2rem;
    color: black;
}

.list-bold span {
    font-weight: normal;
}

.guarantees-list {
    line-height: 18px;
    margin-left: 2rem;
    list-style: disc
}

.vs-con-input-label .vs-con-input {
    width: 100% !important;
}
</style>